import React from 'react'
import {
  Divider,
  ContentContainer,
  ContentHeaderContainer,
  TextBodyContainer,
  IngressLink,
  Button,
  ContentMenuContainer,
  ContentMenuItemContainer,
  VerticalDivider,
  DotIcon,
  DotBtnIcon,
  ListItemsWrapper,
  MediaContainer,
} from '../style'
import { MultilineContentWrapper, Text } from '../../style'
import { useFeatureContext } from '../../../../contexts/FeatureContext'
import { taktId } from '../../../../utils/takt'
import { WidgetTypes } from '../../../../common/constants'

export const FeatureModalContent = (): JSX.Element => {
  const { featureData, featureKeys, unreadFeatures, featureId, featureLabels, setFeatureIdEvent } = useFeatureContext()
  const featureContent = featureKeys.includes(featureId) ? featureData[featureId] : featureData[featureKeys[0]]

  const currIndex = featureKeys.indexOf(featureId)
  const dataTaktId = taktId(WidgetTypes.WhatsNewCenterItem, featureId, true)

  return (
    <>
      <ContentHeaderContainer>
        {unreadFeatures.indexOf(featureContent?.anchorId) >= 0 && <DotIcon type="circle" />}
        <Text type="h4">{featureContent?.title}</Text>
      </ContentHeaderContainer>
      <Divider />
      <ContentContainer>
        {featureContent.embeddedImage && <MediaContainer alt={featureContent.embeddedImage?.altText} src={featureContent.embeddedImage?.link} />}
        <TextBodyContainer>
          {featureContent?.multiLineContent && (
            <MultilineContentWrapper>
              {featureContent.multiLineContent.map((content, index) => (
                <Text key={index} fontSize="base" variant="ccxTextGreyTwo">
                  {content}
                </Text>
              ))}
            </MultilineContentWrapper>
          )}
          {!featureContent?.multiLineContent && featureContent?.content && (
            <Text fontSize="base" variant="ccxTextGreyTwo">
              {featureContent?.content}
            </Text>
          )}
          {featureContent?.externalLink && (
            <IngressLink href={featureContent.externalLink?.link?.link} size="base" external={true} target="_blank" data-takt-id={`${dataTaktId}_link`}>
              {featureContent.externalLink?.link?.label}
            </IngressLink>
          )}
          {featureContent?.internalLink && (
            <Button onClick={() => window.open(featureContent.internalLink?.link?.link, '_self')} data-takt-id={`${dataTaktId}_cta-button`}>
              {featureContent.internalLink?.link?.label}
            </Button>
          )}
        </TextBodyContainer>
      </ContentContainer>
      <ContentMenuContainer>
        <ContentMenuItemContainer onClick={currIndex > 0 ? () => setFeatureIdEvent(featureKeys[currIndex - 1]) : undefined} data-takt-id={`${dataTaktId}_prev-button`}>
          {currIndex > 0 && (
            <>
              <Text type="h6" variant="ccxTextGreyThree">
                {featureLabels?.fitPrev}
              </Text>
              <ListItemsWrapper>
                <Text font={15} lineHeight={22}>
                  {unreadFeatures.indexOf(featureKeys[currIndex - 1]) >= 0 && <DotBtnIcon type="circle" />}
                  {featureData[featureKeys[currIndex - 1]].title}
                </Text>
              </ListItemsWrapper>
            </>
          )}
        </ContentMenuItemContainer>
        <VerticalDivider />
        <ContentMenuItemContainer onClick={currIndex < featureKeys.length - 1 ? () => setFeatureIdEvent(featureKeys[currIndex + 1]) : undefined} data-takt-id={`${dataTaktId}_next-button`}>
          {currIndex < featureKeys.length - 1 && (
            <>
              <Text type="h6" variant="ccxTextGreyThree">
                {featureLabels?.fitNext}
              </Text>
              <ListItemsWrapper>
                <Text font={15} lineHeight={22}>
                  {unreadFeatures.indexOf(featureKeys[currIndex + 1]) >= 0 && <DotBtnIcon type="circle" />}
                  {featureData[featureKeys[currIndex + 1]].title}
                </Text>
              </ListItemsWrapper>
            </>
          )}
        </ContentMenuItemContainer>
      </ContentMenuContainer>
    </>
  )
}
